/* tslint:disable */
/* eslint-disable */
/**
 * Payment Service API
 * 통합 정리된 결제 서비스 API 명세 - 완전 React 마이그레이션  **주요 개선사항:** - 모든 Thymeleaf 페이지를 REST API로 변환 - 기능별 그룹화된 경로 구조 - 표준화된 응답 형식 - React SPA 완전 지원  **API 구조:** - 결제수단 관리: `/api/v1/payment-methods/_*` - 구독 관리: `/api/v1/subscriptions/_*`  - 플랜 관리: `/api/v1/plans/_*` - 주문 관리: `/api/v1/orders/_*` - 대시보드: `/api/v1/dashboard/_*` - NicePay 결제: `/api/v1/payment/nicepay/_*` - 세션 관리: `/api/v1/auth/_*` 
 *
 * The version of the OpenAPI document: 2.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * 플랜 기본 정보
 * @export
 * @interface PlanResponse
 */
export interface PlanResponse {
    /**
     * 플랜 ID
     * @type {string}
     * @memberof PlanResponse
     */
    'id': string;
    /**
     * 상품 ID
     * @type {string}
     * @memberof PlanResponse
     */
    'productId': string;
    /**
     * 플랜명
     * @type {string}
     * @memberof PlanResponse
     */
    'name': string;
    /**
     * 플랜 설명
     * @type {string}
     * @memberof PlanResponse
     */
    'description'?: string;
    /**
     * 상품 코드
     * @type {string}
     * @memberof PlanResponse
     */
    'productCode': string;
    /**
     * 가격 (원 단위)
     * @type {string}
     * @memberof PlanResponse
     */
    'price': string;
    /**
     * 통화
     * @type {string}
     * @memberof PlanResponse
     */
    'currency': string;
    /**
     * 결제 주기
     * @type {string}
     * @memberof PlanResponse
     */
    'billingCycle': PlanResponseBillingCycleEnum;
    /**
     * 무료 체험 일수
     * @type {string}
     * @memberof PlanResponse
     */
    'trialDays'?: string;
    /**
     * 기능 목록
     * @type {Array<string>}
     * @memberof PlanResponse
     */
    'features'?: Array<string>;
    /**
     * 추천 플랜 여부
     * @type {boolean}
     * @memberof PlanResponse
     */
    'isRecommended'?: boolean;
    /**
     * 플랜 상태
     * @type {string}
     * @memberof PlanResponse
     */
    'status': PlanResponseStatusEnum;
    /**
     * 정렬 순서
     * @type {string}
     * @memberof PlanResponse
     */
    'sortOrder'?: string;
    /**
     * 생성일시
     * @type {string}
     * @memberof PlanResponse
     */
    'createdAt'?: string;
    /**
     * 
     * @type {string}
     * @memberof PlanResponse
     */
    'updatedAt'?: string;
    /**
     * 표시용 플랜 이름
     * @type {string}
     * @memberof PlanResponse
     */
    'displayName'?: string;
    /**
     * 빌링 플랜 여부
     * @type {boolean}
     * @memberof PlanResponse
     */
    'isBillingPlan'?: boolean;
    /**
     * 활성 상태
     * @type {boolean}
     * @memberof PlanResponse
     */
    'isActive'?: boolean;
    /**
     * 최대 사용자 수
     * @type {string}
     * @memberof PlanResponse
     */
    'maxUsers'?: string;
    /**
     * 저장 공간 제한 (GB)
     * @type {string}
     * @memberof PlanResponse
     */
    'storageLimit'?: string;
}

export const PlanResponseBillingCycleEnum = {
    Monthly: 'MONTHLY',
    Yearly: 'YEARLY',
    OneTime: 'ONE_TIME'
} as const;

export type PlanResponseBillingCycleEnum = typeof PlanResponseBillingCycleEnum[keyof typeof PlanResponseBillingCycleEnum];
export const PlanResponseStatusEnum = {
    Active: 'ACTIVE',
    Inactive: 'INACTIVE'
} as const;

export type PlanResponseStatusEnum = typeof PlanResponseStatusEnum[keyof typeof PlanResponseStatusEnum];


